export default function isUserSubscribed(user) {
    if (!user) return false;
    if (user.status?.toLowerCase() === 'active') return true;
    const sportsHub = user.subscriptionCategories?.find(
        cat => cat.category === 'SportsHub'
    );
    if (sportsHub && sportsHub.status === 1) return true;
    return false;
}
